import TagManager from '@sooro-io/react-gtm-module';

export const InitializeGTM = () => {
  try {
    const gtmId = (process.env as unknown as any).REACT_APP_GTM_KEY || 'GTM-K67SCRK';
    if (!gtmId) {
      console.warn('GTM ID not found');
      return;
    }
    const tagManagerArgs = {
      gtmId: gtmId,
    };

    TagManager.initialize(tagManagerArgs);
  } catch (e) {
    console.warn('Error initializing analytics', e);
  }
};
